/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ErrorWrapper} from "./error.wrapper";
import {ExceptionEntity} from "../../exception.model";
import {Injectable} from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class HttpErrorResponseWrapper implements ErrorWrapper {
    transform(error: any): ExceptionEntity {
        if (error instanceof HttpErrorResponse) {
            const exception = new ExceptionEntity();
            exception.message = error.name;
            exception.truncatedStackTrace =
                "Message:" + error.message +
                "URL: " + error.url +
                "\n Status: " + error.status;
            exception.stackTrace = JSON.stringify(error);
            return exception;
        } else {
            return null;

        }
    }

    canTransform(error: any): boolean {
        return (error instanceof HttpErrorResponse);
    }
}
